import React from 'react';
import UserInfo from '../UserInfo'
import WarhammerResultSummary from './WarhammerResultSummary';

var diceTypes = [
  'challenge', 'characteristic', 'conservative',
  'expertise', 'fortune', 'misfortune', 'reckless',
];

var diceDisplayKey = 0;
var diceFaceStyle = {
  maxWidth: '30px',
  maxHeight: '30px',
};

var WarhammerResult = ({ result }) => {
  var display = [];

  diceTypes.forEach(diceType => {
    if (result[diceType]) {
      result[diceType].forEach(diceFace => {
        var imgSrc = `/diceImages/warhammer/diceFaces/${diceType}/${diceType}`;
        if (diceFace.length > 0) {
          imgSrc += `-${diceFace}`;
        }
        imgSrc += '.png';

        display.push(<img style={diceFaceStyle} key={diceDisplayKey++} src={imgSrc} alt={diceType} />);
      })
    }
  });

  var numberFaceStyle = {
    height: 24,
    minWidth: 24,
    padding: '0 2px',
    lineHeight: '22px',
    boxSizing: 'border-box',
    backgroundColor: '#eee',
    border: '1px solid #CCC',
    marginRight: 3,
    fontSize: 14,
    display: 'inline-block',
    textAlign: 'center',
    verticalAlign: 'top',
  }

  if (result.random) {
    result.random.forEach(randomRoll => {
      display.push(<span style={numberFaceStyle} key={diceDisplayKey++}>{randomRoll}</span>)
    })
  }

  var captionStyle = (result.caption && result.caption.length > 0) ?
    {
      fontSize: '0.8em',
      lineHeight: '24px',
      verticalAlign: 'top',
    } : {
      display: 'none'
    }

  return <div>
    <div style={{ display: 'inline-block', paddingRight: '5px' }}>
      <UserInfo user={result.user} />
    </div>
    <div style={{ display: 'inline-block' }}>
      {display}
      <span style={captionStyle}>{result.caption}</span>
      <WarhammerResultSummary result={result} />
    </div>
    <hr />
  </div>
}

export default WarhammerResult;
export { diceTypes };



// WEBPACK FOOTER //
// ./src/RollResults/Warhammer/WarhammerResult.js